import '@aofl/picture';
import logo from '@assets/images/aofl-logo.webp';

export const template = (ctx, html) => html`
  <div class="page w-75 bg-white mx-auto pt-5 h-100">
    <div class="text-center">
      <aofl-picture class="mb-5">
        <aofl-source media="(max-width: 252px)" srcset="${logo}" width="252" height="32"></aofl-source>
        <aofl-img src="${logo}" width="252" height="32"></aofl-img>
      </aofl-picture>
    </div>
    <slot name="content"></slot>
    <slot name="footer"></slot>
  </div>
`;
